import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { useUI } from 'store/UI/selectors';
import { useDispatch } from 'react-redux';
import { updateUI } from 'store/UI/actions';

const WRITING_ACTIVITY_MESSAGE = `Reminder:
This activity must be completed entirely in Spanish. Any use of English will result in a deduction of points.

Please focus on using complete sentences, appropriate vocabulary, and correct grammar to clearly express your ideas. Take your time and do your best to demonstrate your Spanish proficiency.`;

const SPEAKING_ACTIVITY_MESSAGE = `Reminder:
This activity must be completed entirely in Spanish. Any use of English will result in a deduction of points.

Also, avoid filler sounds such as "um," "uh," or "uh-huh," as these will lower your score. Speak clearly, confidently, and use complete sentences to demonstrate your language skills.`;

const ModalWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ActivityReminder = styled.div`
    color: #1f2f4b;
    font-size: 13px;
    line-height: 1.65;
    white-space: pre-line;
    background: #fff9e6;
    border: 1px solid #f0e0b8;
    border-radius: 10px;
    padding: 12px 14px;
`;

const ActivityReminderTitle = styled.div`
    font-size: 12px;
    font-weight: 700;
    color: #5c4a12;
    margin-bottom: 8px;
`;

const ScoreMessage = () => {
    const dispatch = useDispatch();
    const openScoreMessageModal = useUI()?.openScoreMessageModal;

    const { hasAudio = false, hasWritten = false } =
        openScoreMessageModal?.isCheckAudiOrWritten ?? { hasAudio: false, hasWritten: false };

    const handleOk = () => {
        dispatch(updateUI({ openScoreMessageModal: null }));
    };

    return (
        <>
            <Modal
                open={openScoreMessageModal?.open}
                width={680}
                title="AI Scoring Information"
                footer={null}
                closeIcon={<CloseOutlined style={{ color: '#ff4d4f' }} />}
                onCancel={handleOk}
            >
                <ModalWrap>
                    {hasAudio ? (
                        <div>
                            <ActivityReminderTitle>Speaking activity</ActivityReminderTitle>
                            <ActivityReminder>{SPEAKING_ACTIVITY_MESSAGE}</ActivityReminder>
                        </div>
                    ) : null}
                    {hasWritten ? (
                        <div>
                            <ActivityReminderTitle>Writing activity</ActivityReminderTitle>
                            <ActivityReminder>{WRITING_ACTIVITY_MESSAGE}</ActivityReminder>
                        </div>
                    ) : null}
                </ModalWrap>
            </Modal>
        </>
    );
};

export default ScoreMessage;
